import { gql } from '@apollo/client';

export const IMPORT_PIPEDRIVE_CSV = gql`
    mutation ImportPipedriveCsv($input: ImportPipedriveCsvInput!) {
        importPipedriveCsv(input: $input) {
            created
            updated
            skipped
            mergedIntoExistingCustomers
            unmappedStages
            unmatchedOwners
            ambiguousMatches
        }
    }
`;
